module.exports = __webpack_public_path__ + "img/hr-rock-huge-06.01c7cb21.png";